import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ButtonGroup } from '@blueprintjs/core'
import { useClaimController } from 'client/controllers/claimController'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const HeaderButtons: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.Common)
  const { setIsOpen } = useClaimController()

  return (
    <ButtonGroup className="items-center gap-5" minimal>
      <a
        className="font-tertiary-bold---12pt p-2 text-text-white transition-colors hover:text-text-secondary hover:no-underline"
        href="https://dashboard.thenumberx.com/login/"
        target="_blank"
        rel="noreferrer"
      >
        {t('actions.log_in')}
      </a>
      <Button
        className={`
            font-tertiary-bold---12pt h-12 rounded-sm
            border-1 border-solid border-surface-tertiary
            px-4 !text-text-tertiary
            transition-colors
            duration-200
            hover:!bg-surface-tertiary
            hover:!text-text-white
            focus:outline-none
        `}
        onClick={() => setIsOpen(true)}
      >
        {t('actions.open_account')}
      </Button>
    </ButtonGroup>
  )
}

export { HeaderButtons }
